import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await api.get("kam/status", options);

  return response;
};

export const post = async (status) => {
  const response = await api.post("kam/status", status);

  return response;
};

export const put = async (status) => {
  const response = await api.put("kam/status", status);

  return response;
};
